import { render, staticRenderFns, recyclableRender, components } from "./list.vue?vue&type=template&id=72c3b981&"
var renderjs
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c3b981')) {
      api.createRecord('72c3b981', component.options)
    } else {
      api.reload('72c3b981', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=72c3b981&", function () {
      api.rerender('72c3b981', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "E:/uni_app/douyin/douyin/components/my/list.vue"
export default component.exports